<!-- Copyright: Seán I. O'Donoghue -->
<!-- From https://github.com/mikerodham/vue-dropdowns -->
<!-- Using the 'menu button' design pattern: -->
<!-- https://www.w3.org/WAI/ARIA/apg/patterns/menubutton/ -->

<template>
  <!-- <transition name="slide-y"> -->
  <menu>
    <template v-for="(option, index) in options" :key="option ?? `separator-${index}`">
      <!-- null: a line between groups (the Videos page's Session menu) -->
      <li v-if="option === null" role="separator" class="separator" />
      <DropdownItem
        v-else
        class="item"
        :to="`${path}/${option}`"
        :selected="option === selected">
        {{ labels[option] || option }}
      </DropdownItem>
    </template>
    <!-- @click="select(option)" -->
  </menu>
  <!-- </transition> -->
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
// eslint-disable-next-line
const props = defineProps({
  options: {default: () => []},
  path: {default: ""},
  selected: {default: ""},
  labels: {default: () => ({})} // an option's shown name, when not the option itself
});
import DropdownItem from "@/components/DropdownRoutes/DropdownItem.vue";
// emit selection event to parent
</script>

<style scoped>
menu {
  position: absolute;
  top: 1.8rem; /* was -5px > overlap button */
  right: 0;
  /* transform: translateX(-50%); */
  padding: 0rem;
  margin-top: 3px;
  min-width: 100%; /* adopts width of parent <button> */
  list-style: none;
  text-align: right;
  background-clip: padding-box;
  background-color: var(--background-color-subtle) !important;
  border: 1px solid var(--border-color);
  border-radius: 0.4rem;
  box-shadow: 0px 0.13rem 0.13rem var(--box-shadow-color);
}
menu item:first-child :deep(a) {
  /* first item: add a bit of space */
  padding-top: 2rem;
}
menu item:last-child :deep(a) {
  /* last item: add a bit of space */
  padding-bottom: 2rem;
}
menu .item :hover {
  color: var(--primary-navigation-color); /* hover color */
  background-color: var(--brand-color);
}
menu .item:last-child :hover {
  border-bottom-left-radius: 0.4rem; /* last item only */
  border-bottom-right-radius: 0.4rem; /* last item only */
}
menu .item:first-child :hover {
  border-top-left-radius: 0.4rem; /* last item only */
  border-top-right-radius: 0.4rem; /* last item only */
}
menu .separator {
  margin: 0.3rem 0.6rem;
  border-top: 1px solid var(--border-color);
}
menu .item :deep(a) {
  color: var(--text-color); /* :deep() overrides default link color */
}
</style>
